import { useEffect, useState } from 'react'
import { Icon } from '../ui'
import { useAppStore } from '../../store/appStore'
import { useSchoolYears } from '../../hooks/useSchoolYears'

const STATUS_LABEL: Record<string, string> = {
  active: 'Active',
  planning: 'Planning',
  closed: 'Closed',
}
const STATUS_CHIP: Record<string, string> = {
  active: 'chip-ok',
  planning: 'chip-info',
  closed: 'chip-neutral',
}

export function YearSwitcher() {
  const { schoolYear, setSchoolYear } = useAppStore()
  const { years, yearInfo } = useSchoolYears()
  const [open, setOpen] = useState(false)
  const info = yearInfo(schoolYear)

  useEffect(() => {
    if (!open) return
    const h = () => setOpen(false)
    window.addEventListener('click', h)
    return () => window.removeEventListener('click', h)
  }, [open])

  return (
    <div style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button className="yearsw" onClick={() => setOpen((o) => !o)} aria-label="Switch school year">
        <Icon name="cal" size={15} />
        <span className="yearsw-lbl">{info.label}</span>
        <Icon name="chevD" size={14} />
      </button>
      {open && (
        <div className="year-menu" role="menu">
          <div className="year-menu-h">School year</div>
          {years.map((y) => (
            <button
              key={y.value}
              className={`year-item${y.value === schoolYear ? ' on' : ''}`}
              onClick={() => {
                setSchoolYear(y.value)
                setOpen(false)
              }}
            >
              <span className="year-item-lbl">{y.label}</span>
              <span className={`chip ${STATUS_CHIP[y.status]}`} style={{ marginLeft: 'auto' }}>
                {STATUS_LABEL[y.status]}
              </span>
              {y.value === schoolYear && <Icon name="check" size={14} style={{ color: 'var(--navy)' }} />}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
